export enum PreferredSleepingPositionEnum {
  SIDE = 'side',
  BACK = 'back',
  STOMACH = 'stomach',
}
